//
// Copyright (c) 2011-2019 by Curalate, Inc.
//
import { PojoSet } from 'pojo-sets';

export interface IPinnedMediaToolbarState {
  openContexts: PojoSet<PinnedMediaToolbarContext>;
}

export enum PinnedMediaToolbarContext {
  GALLERIES_DASHBOARD = 'PINNED_MEDIA_TOOLBAR_CONTEXT/GALLERIES_DASHBOARD',
  PREVIEW_GALLLERY_MODAL = 'PINNED_MEDIA_TOOLBAR_CONTEXT/PREVIEW_GALLERY_MODAL',
}
